// import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { CompaniesUsersService } from '../../../services';
import CompaniesUsersManagersGetters from './getters';
import CompaniesUsersManagersMutations from './mutations';
import CompaniesUsersManagersState from './state';

const companiesUsersService = new CompaniesUsersService();

export default class CompaniesUsersManagersActions extends Actions<
CompaniesUsersManagersState,
CompaniesUsersManagersGetters,
CompaniesUsersManagersMutations,
CompaniesUsersManagersActions
> {
  // получение данных о компаниях-пользователях ЛКП с сервера

  async get_companies_users_managers() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_COMPANIES_USERS_MANAGERS(true);
      const { data, meta } = await companiesUsersService.get_companies_users_managers(payload);

      this.mutations.SET_COMPANIES_USERS_MANAGERS(data.items);
      this.mutations.SET_COMPANIES_USERS(data.companies);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_COMPANIES_USERS_MANAGERS(false);
    }
  }
}
